var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "package-info" }, [_c('div', { staticClass: "info" }, [_c('h2', { staticClass: "name" }, [_vm._v(_vm._s(_vm.config.name))]), _vm._v(" "), _c('el-form', _vm._l(_vm.config.info, function (item) {
    return _c('el-form-item', { key: item.label, attrs: { "label": item.label } }, [_vm._v("\n        " + _vm._s(item.value) + "\n      ")]);
  }), 1)], 1), _vm._v(" "), !this.config.hideAction ? _c('div', { staticClass: "action-bar" }, [_vm._t("action-handler")], 2) : _vm._e()]);
};
var staticRenderFns = [];

export { render, staticRenderFns };